import { render, staticRenderFns } from "./u-chip-flat-tile.vue?vue&type=template&id=ea2b737e&scoped=true&"
import script from "./u-chip-flat-tile.vue?vue&type=script&lang=js&"
export * from "./u-chip-flat-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2b737e",
  null
  
)

export default component.exports